import {
  CreateNamedEntity,
  EditNamedEntity,
} from '../model/request/named-entities'
import { NamedEntity } from '../model/response'
import { ApiClient } from '../util/ApiClient'

export class DisciplinaryCaseTypesService {
  public static async create(details: CreateNamedEntity) {
    return ApiClient.post<CreateNamedEntity, NamedEntity>(
      'disciplinary-case/create',
      details,
      CreateNamedEntity
    )
  }

  public static async list() {
    return ApiClient.get<NamedEntity[]>('disciplinary-case/view-list')
  }

  public static async retrieve(id: number | string) {
    return ApiClient.getOne<NamedEntity>('disciplinary-case/show', id)
  }

  public static async update(id: number | string, details: EditNamedEntity) {
    return ApiClient.patch<EditNamedEntity, NamedEntity>(
      'disciplinary-case/update',
      id,
      details,
      EditNamedEntity
    )
  }
}
